import React from 'react';
import { motion } from 'framer-motion';
import { whatYouGet, trustLine } from '../data/content';
import { Eyebrow, Heading, Section } from './Primitives';
export function WhatYouGet() {
  return <Section className="bg-white" ariaLabel="What you get for $29" data-id="element-245" data-mp="l3uvq4qdraa1">
      <div className="mx-auto max-w-2xl text-center" data-id="element-246" data-mp="l5pkju4rvmje">
        <Eyebrow data-id="element-247" data-mp="q37iyql5yjd5">Everything included for $29</Eyebrow>
        <Heading data-id="element-248" data-mp="1ds0g2qdiux9c">What your dog's plan includes.</Heading>
        <p className="mt-4 text-lg leading-relaxed text-ink-500" data-id="element-249" data-mp="1dsim2epzkpug">
          One simple purchase. Personalized guidance for your dog's everyday nutrition and care.
        </p>
      </div>

      <ul className="mx-auto mt-8 grid max-w-4xl gap-2.5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-250" data-mp="141fm5g8smgwr">
        {whatYouGet.map((item, index) => <motion.li key={item.label} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.35,
        delay: Math.min(index, 4) * 0.05,
        ease: 'easeOut'
      }} className="flex items-start gap-3 rounded-xl border border-orangey-100 bg-cream px-4 py-3.5" data-id="element-251" data-mp="18z7gsi0toh4n" data-mpi={index}>
            <span aria-hidden="true" className="text-xl leading-none" data-id="element-252" data-mp="2qewhdr1r27h1">
              {item.emoji}
            </span>
            <span className="font-semibold leading-snug text-ink-700" data-id="element-253" data-mp="30f6vddvlzix9">{item.label}</span>
          </motion.li>)}
      </ul>

      <p className="mt-7 text-center font-mono text-[0.68rem] font-semibold uppercase tracking-[0.14em] text-ink-400" data-id="element-254" data-mp="3e5ac5pbpykfb">
        {trustLine}
      </p>
    </Section>;
}